const checkoutErrors = {
  'Оплата не из России пока не настроена': 'foreignUnavailable',
  'Для выбранного товара не настроена зарубежная цена': 'foreignPriceMissing',
  'Для новых платежей Prodamus необходимо настроить USD': 'foreignUnavailable',
  'Покупка кредитов доступна только для Premium тарифа': 'premiumCreditsRequired',
  'Товар не найден или недоступен': 'productUnavailable',
  'Пакет кредитов настроен некорректно': 'productUnavailable',
  'Промокод недоступен для покупки кредитов': 'creditsPromoUnavailable',
  'Промокод недействителен': 'invalidPromo',
  'Промо-код не найден': 'invalidPromo',
  'Промо-код не указан': 'invalidPromo',
  'Промо-код неактивен': 'inactivePromo',
  'Срок действия промо-кода истёк': 'expiredPromo',
  'Лимит использований промо-кода исчерпан': 'exhaustedPromo',
  'Промо-код исчерпан': 'exhaustedPromo',
  'Вы уже использовали этот промо-код': 'usedPromo',
  'Для оплаты необходимо указать email в профиле': 'emailRequired',
};

export function paymentResponseError(error, translate, fallbackKey) {
  const message = error.response?.data?.error;
  const key = Object.hasOwn(checkoutErrors, message) ? checkoutErrors[message] : null;
  return translate(key ? `payment.${key}` : fallbackKey);
}

export function paymentErrorMessage(error, translate, provider) {
  const data = error.response?.data;
  if (provider === 'prodamus' || data?.errorCode === 'PRODAMUS_CHECKOUT_FAILED') {
    const message = translate('payment.checkoutFailed');
    // Only accept the server UUID, never interpolate arbitrary response text.
    return /^[a-f0-9-]{36}$/i.test(data?.errorId || '')
      ? `${message} ${translate('payment.errorReference', { id: data.errorId })}` : message;
  }
  return paymentResponseError(error, translate, 'legacy.Ошибка создания платежа. Попробуйте позже.');
}
